import { FormActionsMui } from '@app/components/form/actions/FormActionsMui';
import { zodResolver } from '@hookform/resolvers/zod';
import { socialExport } from '@mi-front/api-clients';
import { Grid, Stack } from '@mui/material';
import { FormContainer, SwitchElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { z } from 'zod';
import { BaseSettingsFormProps } from '../../hooks/useSocialExportFactory';
import { FormSection } from '../../screens/manage/platforms/FormSection';

export const instagramSettingsSchema = z.object({
  shareToFeed: z.boolean().nullable().optional(),
});

export function InstagramSettingsForm({
  stationId,
  onUpdate,
  defaultSettings,
}: BaseSettingsFormProps<socialExport.InstagramSettingsDto>) {
  const { $t } = useIntl();
  return (
    <FormContainer
      mode="onBlur"
      values={{
        shareToFeed: defaultSettings?.shareToFeed ?? true,
      }}
      onSuccess={async (formData) => {
        await onUpdate({
          shareToFeed: formData.shareToFeed ?? null,
        });
      }}
      resolver={zodResolver(instagramSettingsSchema)}
    >
      <FormSection
        title={$t({
          id: 'socialExport.form.defaultValuesUploads',
          defaultMessage: 'Valores por defecto para uploads',
        })}
      >
        <Grid container>
          <Grid item md={4}>
            <Stack spacing={2}>
              <SwitchElement
                name="shareToFeed"
                label={$t({
                  id: 'socialExport.form.shareToFeed',
                  defaultMessage: 'Compartir también en el feed',
                })}
                color="primary"
              />
            </Stack>
          </Grid>
        </Grid>
      </FormSection>
      <FormActionsMui cancel />
    </FormContainer>
  );
}
